module.exports = __webpack_public_path__ + "assets/b1a87567ece57450b48c0e12cb837eeb.jpg";